import { useSelector } from "react-redux";
import Frais from "../../components/frais";
import MultiStep from "../../components/multiStep";
import Recap from "../../components/recapPresta";
import TopHeader from "../../components/TopHeader";
import InfoPrestations from "./infoPrestations";
import Facturation from "./facturation";
import Identification from "./identification";
import Footer from "../../components/Footer";
import { useMemo, useRef } from "react";

const Layout = (props) => { 
 
  const {isAuthenticated,isAuthenticatedRdv} = useSelector((state)=>state.user)
  const initialAuthRef = useRef(isAuthenticated);
 // This will regenerate steps whenever isAuthenticated changes
 const steps = useMemo(() => {
  const baseSteps = [
    {
      paths: ["/details-rdv", "/choisir-prestation"],
      component: InfoPrestations,
      label: "Informations de prestations",
      step: 1,
    },
    {
      paths: ["/identification", "/register-rdv"],
      component: Identification,
      label: "Identification",
      step: 2,
    },
    {
      paths: ["/payment", "/facturation"],
      component: Facturation,
      label: "Paiement",
      step:  3,
    },
  ];

  // if (!initialAuthRef.current || isAuthenticatedRdv) { // Use initial value
  //   baseSteps.splice(1, 0, {
  //     paths: ["/identification", "/register-rdv"],
  //     component: Identification,
  //     label: "Identification",
  //     step: 2,
  //   });
  // }

  return baseSteps;
}, []); // Dependency array ensures regeneration when auth changes

  
  // Usage in your component:

  // const steps = getSteps(isAuthenticated);
  return (
    <>
    <div style={{backgroundColor:props?.identification || props?.greyBg ? '#F6F6F6':'#fff',minHeight:'100svh'}} className="pb-16">
       <TopHeader btn={ props?.btn}/>
     {props?.conf && <MultiStep steps={steps} currentStep={props?.currentStep} from={props.from}  /> }
      <div className="container">
        <div className="row mt-48">
          <div className="col-md-8 mx-auto">{props?.children}</div>
           {props?.recap &&<div className="col-md-4">
          
           <> 
           <Recap
              etablissement={props?.etablissement}
              prestation={props?.prestation}
              from={props?.from}
              btnPay={props?.btnPay}
              reservation_id={props?.reservation_id}
            />
            {props?.conf &&  <Frais />}
          
            </>
            
           
          </div>} 
        </div>
      </div>
    </div>
    {!props?.conf && <Footer/>}
    </>
  );
};
export default Layout;
